<form>
  <div class="form-group">
    <label>{{ label }}</label>
    <div>
      <label class="inline-radio checkbox" [class.selected]="required">
        <input
          disabled="{{ disable }}"
          [(ngModel)]="required"
          type="radio"
          aria-label="Yes"
          [name]="name"
          [value]="true"
          (ngModelChange)="handleUpdate($event)" />
        Yes
      </label>
      <label class="inline-radio checkbox" [class.selected]="!required">
        <input
          disabled="{{ disable }}"
          [(ngModel)]="required"
          type="radio"
          aria-label="No"
          [name]="name"
          [value]="false"
          (ngModelChange)="handleUpdate($event)" />
        No
      </label>
      <ng-container *ngIf="attachmentData && attachmentData?.length >= 0">
        <div *ngFor="let attachment of attachmentData" class="file-block">
          <span class="file-name">
            <a [href]="attachment.url" target="_blank">
              <span class="name">{{ attachment.name }}</span>
            </a>
            <span (click)="handleDelete(attachment.id)" class="file-delete"><i class="fal fa-times fa-sm"></i></span>
          </span>
        </div>
      </ng-container>
      <ng-container *ngIf="attachmentData && attachmentData?.length === 0">
        <button type="button" class="btn-file" (click)="fileUploader.click()">Upload file...</button>
        <input
          hidden
          type="file"
          #fileUploader
          [accept]="allowedDocumentType"
          (change)="captureFile($event)"
          multiple />
      </ng-container>
      <button *ngIf="datePrompt" type="button" class="btn-calendar" (click)="captureDate($event)">
        <i class="fal fa-calendar"></i>
      </button>
    </div>
  </div>
</form>
